import { render, staticRenderFns } from "./TagControl.vue?vue&type=template&id=1e7008e8"
import script from "./TagControl.vue?vue&type=script&lang=js"
export * from "./TagControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports